<template>
  <div>
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <span class="demonstration">开始时间:</span>
            <el-date-picker
              v-model="search.beginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder
            ></el-date-picker>
          </div>
          <div class="form-group">
            <span class="demonstration">结束时间:</span>
            <el-date-picker
              v-model="search.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
            <!-- <span class='download_btn'><button  @click="downloadExcel" type="button" class="btn btn-primary">导出EXCEl</button></span> -->
            <!-- <span class='refresh_btn'><div class='reload-container' ><a class="reload"   @click="reloads()"><i class="el-icon-refresh"></i>刷新</a></div></span> -->
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="姓名"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="统计时间"
            prop="date"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="收入总额"
            prop="realMoney"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="追缴欠费(总额)"
            prop="arrears"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付宝"
            prop="alipay"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="微信"
            prop="wechat"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="现金"
            prop="cash"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="追缴欠费(支付宝)"
            prop="arrearsAlipay"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="追缴欠费(微信)"
            prop="arrearsWechat"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="追缴欠费(现金)"
            prop="arrearsCash"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { getChargeStatistics, fetchPropertyList } from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

import dayjs from 'dayjs';

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        beginTime: dayjs().subtract(1,'month').format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
        propertyId: null,
      },

      propertyList: [],
      moduleName: "parking",
      value4: "",
      showDate: {
        year: "",
        month: "",
      },
      tableListData: [],
      tableListDataByDay: {},
      tableListDataExcel: {},
      tableListDataAll: {},
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.search.beginTime = "";
      this.search.endTime = "";
      if (node.type != "property") {
        this.treeData.propertyId = "";
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
        this.getPage(pageObj);
        this.tableListData = [];
        return;
      } else {
        this.treeData.propertyId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getChargeStatistics(), {
        parentId: this.search.propertyId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    searchList: function () {
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginTime) 
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      var compareTime = this.timeCompare(this.search.endTime,dayjs(this.search.beginTime).add(1,'month').format('YYYY-MM-DD'));     

      if (compareTime) {
        return this.$layer.msg("请选择一个月以内的日期", { time: 1 });
      }

      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    getAllProperty() {
      return this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    async initProperty() {
      await this.getAllProperty();
      this.search.propertyId = this.propertyList[0].id;
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/chargeStatisticsExport",
        {
          parentId: this.search.propertyId,
          beginTime: this.search.beginTime,
          endTime: this.search.endTime,
        },
        "收费员日报"
      );
    },
  },
  computed: {
    /*...mapState({
				curIndex: state => state.page.curIndex,
				rowsCount: state => state.page.rowsCount
			}),*/

    ...mapGetters(["elements"]),
    // permiss(){
    // 	this.parklist_btn_add = this.elements['parklist:btn_add'];
    // 	this.parklist_btn_rule = this.elements['parklist:btn_rule'];
    // this.parklist_btn_pkset = this.elements['parklist:btn_pkset'];
    // this.parklist_btn_control = this.elements['parklist:btn_control'];
    // this.parklist_btn_person = this.elements['parklist:btn_person'];
    // this.parkset_btn_edit = this.elements['parklist:btn_edit'];
    // this.parklist_btn_remove=this.elements['parklist:btn_remove'];
    //console.log("parklist_btn_remove")
    //console.log(this.parklist_btn_remove)
    // }
  },
  components: {
    Page,
    // Refresh,
    AreaTree,
  },
  created: function () {
    // this.permiss;
  },
  mounted: function () {
    this.initProperty();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  /* background: #f9f9fb;
  /* height:65px; 
  border-bottom: 10px solid #eff2f7; */
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
  overflow-x: auto;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
table {
  border: 1px solid #ccc;
}
table tr td {
  border: 1px solid #ccc;
}
.reload-container {
  display: inline-block;
  /* margin-top:8px; */
}
.reload {
  /* margin: 0px 10px; */
  cursor: pointer;
  color: #67c23a !important;
}
.reload:hover {
  color: rgb(45, 107, 15) !important;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}

/* 表格美化样式 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
}

/* 表头样式优化 - 简化版本 */
.el-table th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border: none !important;
  border-bottom: 2px solid #e4e7ed !important;
  transition: background-color 0.2s ease;
}

.el-table th:hover {
  background: #e9ecef !important;
}

/* 表格行悬停效果 - 简化版本 */
.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 表格容器美化 - 简化版本 */
.list-right {
  background: #ffffff;
  border-radius: 8px;
 
  overflow: hidden;
  position: relative;
}


/* 按钮样式美化 - 简化版本 */
.btn {
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: none;
  padding: 8px 16px;
}

.btn-primary {
  background: #409eff;
  color: white;
}

.btn-primary:hover {
  background: #337ecc;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
}

.btn-default {
  background: #909399;
  color: white;
}

.btn-default:hover {
  background: #7a7d81;
  box-shadow: 0 2px 4px rgba(144, 147, 153, 0.2);
}
</style>